import { Touchpoint } from '../../../ScriptingEngineEnvironment';

export class DocumentValidationTouchpoint implements Touchpoint.DocumentValidation.IDocumentValidationTouchpoint {
    register(): void {
        // we currently do not extract any metadata about validation function registrations.
    }
}
